module.exports = require('./invoice-edit').extend()
